/**
 * The day a test setup is working as of — the walkthrough control.
 *
 * The server decides whether it listens (`as_of_enabled` on /health; never in
 * production) and never takes a day later than the real one. This file only
 * remembers the officer's choice in this browser and sends it with every
 * request. Nothing here computes a date: the server's `today` is still the
 * only date the app works to.
 */

export const AS_OF_HEADER = 'X-AWEIL-As-Of'
const KEY = 'aweil.asOf'

/** The chosen day as `YYYY-MM-DD`, or null when working as of today. */
export function readAsOf(): string | null {
  try {
    const value = window.localStorage.getItem(KEY)
    return value && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null
  } catch {
    return null
  }
}

export function writeAsOf(value: string | null): void {
  try {
    if (value) window.localStorage.setItem(KEY, value)
    else window.localStorage.removeItem(KEY)
  } catch {
    // Storage refused (a private window): the control simply does not stick.
  }
}

/** The header to add to a request, when a day is chosen. */
export function asOfHeaders(): Record<string, string> {
  const value = readAsOf()
  return value ? { [AS_OF_HEADER]: value } : {}
}
